import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { ThemeVersion } from "@/lib/api/types";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";
import { invalidateAdminThemes } from "@/lib/query/core/invalidation";
import { queryKeys } from "@/lib/query/core/query-keys";

type UpdateThemeVersionMetaInput = {
  themeId: string;
  versionId: string;
  thumbnailUrl?: string;
  changelogAr?: string;
  changelogEn?: string;
};

export function useUpdateThemeVersionMetaMutation() {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: ({ themeId, versionId, ...body }: UpdateThemeVersionMetaInput) =>
      apiJsonClient<ThemeVersion>(
        endpoints.admin.themeVersionMeta(themeId, versionId),
        {
          method: "PATCH",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(body),
        },
      ),
    onSuccess: async (_data, variables) => {
      await invalidateAdminThemes(queryClient);
      await queryClient.invalidateQueries({
        queryKey: queryKeys.admin.themeById(variables.themeId),
        exact: true,
      });
    },
  });

  return {
    mutateAsync: mutation.mutateAsync,
    isPending: mutation.isPending,
    error: mutation.error,
    reset: mutation.reset,
  };
}
